import React from 'react';
import { Alert, CircularProgress, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { historyChange, historyWhat } from './policyEdit';

// Who changed the policy, when, and what (newest first). The history itself cannot be changed or deleted.
function HistoryTab({ history }) {
  if (!history || history.state === 'loading') return <Stack alignItems="center" sx={{ py: 6 }}><CircularProgress /></Stack>;
  if (history.state === 'error') return <Alert severity="error">{history.error}</Alert>;
  const rows = Array.isArray(history.items) ? history.items : [];
  if (rows.length === 0) return <Typography variant="body2" color="text.secondary">Nothing has been changed yet.</Typography>;
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 520 }}>
      <Table size="small" stickyHeader aria-label="History">
        <TableHead>
          <TableRow>{['When (UTC)', 'Who', 'Change', 'What'].map((h) => <TableCell key={h} sx={{ fontWeight: 700 }}>{h}</TableCell>)}</TableRow>
        </TableHead>
        <TableBody>
          {rows.map((h) => (
            <TableRow key={h.id} hover>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>{String(h.utc || '').replace('T', ' ').slice(0, 19)}</TableCell>
              <TableCell>{h.by}</TableCell>
              <TableCell>{historyChange(h)}</TableCell>
              <TableCell>{historyWhat(h)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default HistoryTab;
